<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3> {{ label.get('time_options') }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('time_options_time_zone') }}</label>
          </div>

          <div class="action-buttons" v-if="saveTimeZoneChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancelTimeZoneChanges"
            >
              <i class="atto atto-close-btn" />
              {{label.get('cancel')}}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                @click="saveTimeZoneChanges"
            >
              <i class="atto atto-selected-tick" />
              {{label.get('save_changes')}}
            </button>
          </div>
        </div>
        <div class="content-wrapper subsection">
          <div class="time-options-row">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="fixedTimeZone"
              >
                {{ label.get('time_options_fixed_time_zone') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('time_options_fixed_time_zone_description') }}
              </p>
            </div>
            <div
                class="select-wrapper"
                :class="{'deactivated': !fixedTimeZone}"
            >
              <div class="field-wrap">
                <i class="atto atto-rdir-arrow-b subsequent-icon" />
                <p>
                  {{ label.get('time_options_time_zone') }}
                </p>
                <search-dropdown-component
                    :value="timezone"
                    :options="timezones"
                    :placeholder="label.get('search_timezone')"
                    @onOptionSelected="onTimezoneSelected"
                    @onInputChange="onTimezoneSearch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('time_options_time_format') }}</label>
          </div>
          <!--<div class="action-buttons" v-if="saveTimeFormatChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancelTimeFormatChanges"
            >
              <i class="atto atto-close-btn" />
              {{label.get('cancel')}}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                :disabled="disabledSubmitButton"
                @click="saveTimeFormatChanges"
            >
              <i class="atto atto-selected-tick" />
              {{label.get('save_changes')}}
            </button>
          </div>-->
        </div>
        <div class="content-wrapper subsection">
          <div class="time-options-row">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="decimalTimeFormat"
                  @change="changeDecimalTimeFormat"
              >
                {{ label.get('time_options_use_decimal_hours') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('time_options_use_decimal_hours_description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('time_options_timesheet_rounding') }}</label>
          </div>
          <div class="action-buttons" v-if="saveTimesheetRoundingEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancelTimesheetRoundingChanges"
            >
              <i class="atto atto-close-btn" />
              {{label.get('cancel')}}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                :disabled="disabledSubmitButton"
                @click="saveTimesheetRoundingChanges"
            >
              <i class="atto atto-selected-tick" />
              {{label.get('save_changes')}}
            </button>
          </div>
        </div>
        <div class="subsection content-wrapper">
          <div class="time-options-row">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="timesheetRounding"
                  @change="onTimesheetRounding"
              >
                {{ label.get('time_options_round_clock_in_out_times') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('time_options_round_clock_in_out_times_description') }}
              </p>
            </div>
            <div
                class="select-wrapper"
                :class="{'deactivated': !timesheetRounding}"
            >
              <div class="field-wrap rounding-increment">
                <i class="atto atto-rdir-arrow-b subsequent-icon" />
                <p>
                  {{ label.get('time_options_rounding_increment') }}:
                </p>
                <select-dropdown-component
                    :value="roundingValue"
                    placeholder="5"
                    :options="increment_options"
                    @onOptionSelected="changeTimesheetIncrement"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('time_options_night_shift_tracking') }}</label>
          </div>
        </div>
        <div class="content-wrapper subsection">
          <div class="time-options-row">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="timesheetMidnight"
                  @change="changeTimesheetMidnight"
              >
                {{ label.get('split_timesheets_at_midnight') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('split_timesheets_description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('time_options_group_same_day_entries_title') }}</label>
          </div>
        </div>
        <div class="content-wrapper subsection">
          <div class="time-options-row">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="groupSameDayEntries"
                  @change="changeGroupSameDayEntries"
              >
                {{ label.get('time_options_group_same_day_entries') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('time_options_group_same_day_entries_description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import TimeOptionsService from './services/TimeOptionsService';
    import SelectDropdownComponent from '../../../shared/components/SelectDropdownComponent';
    import SearchDropdownComponent from '../../../shared/components/SearchDropdownComponent';
    import JobSitesService from "../job-sites/services/JobSitesService";
    export default {
        name: "TimeOptionsComponent",
        components: {
            SearchDropdownComponent,
            SelectDropdownComponent
        },
        data() {
            return {
                fixedTimeZone: this.$store.state.timeOption.fixed_timezone,
                decimalTimeFormat: this.$store.state.timeOption.decimal_time_format,
                timesheetRounding: this.$store.state.timeOption.timesheet_rounding,
                timesheetMidnight: this.$store.state.timeOption.split_timesheets_at_midnight,
                groupSameDayEntries: this.$store.state.timeOption.group_same_day_entries,
                roundingValue: this.$store.state.timeOption.rounding_increment,
                saveChangesEnabled: false,
                saveTimeZoneChangesEnabled: false,
                saveTimeFormatChangesEnabled: false,
                saveTimesheetRoundingEnabled: false,
                selectedTimezone: null,
                timezone: null,
                timezones: [],
                timezoneResults: [],
                increment_options: this.getRoundingIncrement(),
                debounce: null,
                disabledSubmitButton: true
            }
        },
        watch: {
            fixedTimeZone(newVal, oldVal) {
              if(newVal !== this.$store.state.timeOption.fixed_timezone) {
                this.saveTimeZoneChangesEnabled = true;
                this.disabledSubmitButton = false;
              } else {
                this.saveTimeZoneChangesEnabled = false;
                this.disabledSubmitButton = true;
              }
            },
            decimalTimeFormat(newVal, oldVal) {
              if(newVal !== this.$store.state.timeOption.decimal_time_format) {
                this.saveTimeFormatChangesEnabled = true;
                this.disabledSubmitButton = false;
              } else {
                this.saveTimeFormatChangesEnabled = false;
                this.disabledSubmitButton = true;
              }
            },
            timesheetRounding(newVal, oldVal) {
              if(newVal !== this.$store.state.timeOption.timesheet_rounding) {
                this.saveTimesheetRoundingEnabled = true;
                this.disabledSubmitButton = false;
              } else {
                this.saveTimesheetRoundingEnabled = false;
                this.disabledSubmitButton = true;
              }
            }
        },
        created() {
            this.fillTimezone()
        },
        methods: {
            getRoundingIncrement(){
                return[
                    { value: 5, label: "5 " + this.label.get('min')},
                    { value: 10, label: "10 " + this.label.get('min')},
                    { value: 15, label: "15 " + this.label.get('min')},
                    { value: 20, label: "20 " + this.label.get('min')},
                    { value: 30, label: "30 " + this.label.get('min')},
                ];
            },
            fillTimezone() {
                if(this.$store.state.timeOption.timezone_city !== null) {
                    this.selectedTimezone = {
                        timezone_city:  this.$store.state.timeOption.timezone_city,
                        timezone_country: this.$store.state.timeOption.timezone_country,
                        timezone_offset: this.$store.state.timeOption.timezone_offset,
                    };
                    this.timezone = {
                        value: 0,
                        label: this.$store.state.timeOption.timezone_city + (this.$store.state.timeOption.timezone_country ? ', '
                            + this.$store.state.timeOption.timezone_country : '')
                    };
                }
            },
            changeTimesheetIncrement(option) {
                let storeRoundingValue = this.$store.state.timeOption.rounding_increment;
                this.saveTimesheetRoundingEnabled = storeRoundingValue !== option.value;
                this.roundingValue = option.value;
                this.disabledSubmitButton = false;
            },
            onTimezoneSearch(query) {
                const _this = this;
                if(query !== undefined && query !== '') {
                    if(_this.debounce) {
                        clearTimeout(_this.debounce);
                    }
                    _this.debounce = setTimeout(() => {
                        TimeOptionsService.searchTimezones(query).then((result) => {
                            _this.timezoneResults = result;
                            _this.timezones = result.map((item, idx) => {
                                return {
                                    value: idx,
                                    label: item.timezone_city + (item.timezone_country ? ', ' + item.timezone_country : '')
                                };
                            });
                        }).catch(() => { });
                    }, 800);
                } else {
                    _this.timezones = [];
                    _this.timezoneResults = [];
                }
            },
            onTimezoneSelected(option) {
                this.timezone = option;
                this.selectedTimezone = this.timezoneResults[option.value];
                this.saveTimeZoneChangesEnabled = true;
            },
            changeDecimalTimeFormat() {
              this.$store.commit('showLoading');
              this.$store.state.timeOption.decimal_time_format = !this.decimalTimeFormat;
              TimeOptionsService.update(this.$store.state.timeOption.id, this.$store.state.timeOption).then((result) => {
                this.$store.commit('hideLoading');
                this.$awn.success(result.data.message);
              }).catch((error) => {
                console.log(error);
                this.$store.commit('hideLoading');
              })
            },
            onTimesheetRounding() {
              this.saveTimesheetRoundingEnabled = true;
            },
            saveTimesheetRoundingChanges() {
              this.disabledSubmitButton = true;
              this.$store.state.timeOption.timesheet_rounding = this.timesheetRounding;
              if(this.timesheetRounding === true){
                this.$store.state.timeOption.rounding_increment = this.roundingValue;
              }
              this.$store.commit('showLoading');
              TimeOptionsService.update(this.$store.state.timeOption.id, this.$store.state.timeOption).then((result) => {
                this.$store.commit('hideLoading');
                this.saveTimesheetRoundingEnabled = false;
                this.$awn.success(result.data.message);
              }).catch((error) => {
                this.$store.commit('hideLoading');
              })
            },
            changeTimesheetMidnight() {
              this.$store.commit('showLoading');
              this.$store.state.timeOption.split_timesheets_at_midnight = !this.timesheetMidnight;
              TimeOptionsService.update(this.$store.state.timeOption.id, this.$store.state.timeOption).then((result) => {
                this.$store.commit('hideLoading');
                this.$awn.success(result.data.message);
              }).catch((error) => {
                console.log(error);
                this.$store.commit('hideLoading');
              });
            },
          changeGroupSameDayEntries() {
            this.$store.commit('showLoading');
            this.$store.state.timeOption.group_same_day_entries = !this.groupSameDayEntries;
            TimeOptionsService.update(this.$store.state.timeOption.id, this.$store.state.timeOption).then((result) => {
              this.$store.commit('hideLoading');
              this.$awn.success(result.data.message);
            }).catch((error) => {
              console.log(error);
              this.$store.commit('hideLoading');
            })

          },
            saveTimeZoneChanges() {
              this.disabledSubmitButton = true;
                if(this.fixedTimeZone && this.selectedTimezone === null) {
                    return false;
                }
                if(this.fixedTimeZone) {
                    this.$store.state.timeOption.timezone_city = this.selectedTimezone.timezone_city;
                    this.$store.state.timeOption.timezone_country = this.selectedTimezone.timezone_country;
                    this.$store.state.timeOption.timezone_offset = this.selectedTimezone.timezone_offset;
                }
                this.$store.state.timeOption.fixed_timezone = this.fixedTimeZone;
                this.$store.commit('showLoading');
                TimeOptionsService.update(this.$store.state.timeOption.id, this.$store.state.timeOption).then((result) => {
                    this.$store.commit('hideLoading');
                    this.saveTimeZoneChangesEnabled = false;
                    this.$awn.success(result.data.message);
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                })
            },
            cancelTimeZoneChanges() {
              this.fixedTimeZone = this.$store.state.timeOption.fixed_timezone;
              this.timezone = {
                value: -1,
                label: this.$store.state.timeOption.timezone_city + ', ' + this.$store.state.timeOption.timezone_country
              };

              this.saveTimeZoneChangesEnabled = false;
            },
            cancelTimeFormatChanges() {
              this.decimalTimeFormat = this.$store.state.timeOption.decimal_time_format;
              this.saveTimeFormatChangesEnabled = false;
            },
            cancelTimesheetRoundingChanges() {
              this.timesheetRounding = this.$store.state.timeOption.timesheet_rounding;
              this.roundingValue = this.$store.state.timeOption.rounding_increment;
              this.saveTimesheetRoundingEnabled = false;
            },
           /* cancelTimesheetMidnightChanges() {
              this.timesheetMidnight = this.$store.state.timeOption.split_timesheets_at_midnight;
              this.saveTimesheetMidnightEnabled = false;
            },*/
        }
    }
</script>

<style lang="scss">
  .switch-wrapper.check-wrapper .custom-checkbox .custom-control-label{
    font-weight: $roboto-regular;
  }
    .subsection{
        padding: 40px 0;
    }
    .time-options-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;

        .select-wrapper{
            flex-grow: 1;
            position: relative;
            justify-content: flex-end;
            .field-wrap{
                display: flex;
                flex-direction: row;
                align-items: center;
                i.subsequent-icon{
                  margin: 0 4px 0 0;
                  font-size: 11px;
                  color: $atto-font-color;
                }
                p{
                    font: $roboto-regular 0.875rem/1.75rem $roboto-font;
                    color: #262626;
                    margin-bottom: 0;
                    margin-right: 20px;
                }
                .atto-select{
                  flex-grow: 1;
                }
            }

            &.deactivated{
                &::after{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 10;
                }
                i{
                    color: $atto-light-grey;
                }
                p{
                    color: $atto-dark-grey;
                }

                p.info,
                .field-wrap .atto-select .select-heading span,
                .field-wrap p {
                    color: $atto-dark-grey!important;
                }
                .field-wrap i.subsequent-icon,
                .field-wrap .atto-select .select-heading i{
                    color: #f7f7f7;
                }
                .field-wrap .atto-select .select-heading{
                    border-color: #fafafa;
                }
            }
        }
        p.disclaimer{
          color: #666666;
          max-width: 515px;
          margin-top: 4px;
        }
    }
</style>


<style lang="scss" scoped>
  .subsection{
    border: none;
  }
  .time-options-row .select-wrapper{
    width: 302px;
    min-width: 302px;
    display: flex;
  }
  .atto-select.search-filtering{
    max-width: 184px;
    min-width: 184px;
  }
  .time-options-row .select-wrapper.deactivated .field-wrap p{
    color: $atto-not-active;
  }
  .time-options-row .select-wrapper .field-wrap.rounding-increment .atto-select {
    width: 124px;
  }
  .check-wrapper.switch-wrapper{
    width: 45%;
  }
</style>